"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PageAccordionGeneric = _interopRequireDefault(require("../PageAccordionGeneric/PageAccordionGeneric"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
var _List = _interopRequireDefault(require("../List/List"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.consultation-container .accordion-content .bottom {\n  display: flex;\n  gap: 24px; }\n  .consultation-container .accordion-content .bottom a {\n    color: #000000; }\n";
  const fileName = "Consultation_Consultation";
  const element = document.querySelector("style[data-sass-component='Consultation_Consultation']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const AccordionContent = _ref => {
  let {
    item,
    lang,
    translate
  } = _ref;
  const date = _react.default.useMemo(() => {
    const splited_date = item.deadline?.split('-');
    if (splited_date?.length !== 3) return '';
    return `${splited_date[2]}.${splited_date[1]}.${splited_date[0]}`;
  }, [item.deadline]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, item.link_downloads_box?.length > 0 && /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: item.link_downloads_box[0].link_downloads_box_element,
    lang: lang,
    isConsultation: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom sia-margin-04-bottom sia-margin-01-top"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06"
  }, translate('cms.consultations.first'), ": ", date), item.email && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06"
  }, "|"), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06"
  }, translate('cms.consultations.contact'), ":", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: `mailto:${item.email}`
  }, item.email))))));
};
const Consultation = _ref2 => {
  let {
    items,
    history,
    lang,
    translate
  } = _ref2;
  const ongoing_consultations = items.ongoing_consultations?.map(el => {
    return {
      accordion_generic_el_title: [`${el.code} - ${el.title}`],
      col_0: {
        content: el
      }
    };
  });
  const past_consultations = items.past_consultations?.map(el => {
    const splited_date = el.deadline?.split('-');
    const date = splited_date?.length !== 3 ? '' : `${splited_date[2]}.${splited_date[1]}.${splited_date[0]}`;
    return {
      content: `${el.code} - ${el.title} - ${date}`
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "consultation-container"
  }, ongoing_consultations?.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: " sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-04 sia-margin-03-bottom"
  }, translate('cms.consultations.actuals')), /*#__PURE__*/_react.default.createElement(_PageAccordionGeneric.default, {
    item: {
      accordion_generic_element: ongoing_consultations
    },
    Item: AccordionContent,
    history: history,
    lang: lang,
    translate: translate
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: " sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-10 sia-margin-03-bottom"
  }, translate('cms.consultations.actuals.none'))), past_consultations?.length > 0 && /*#__PURE__*/_react.default.createElement(_List.default, {
    title: translate('cms.consultations.past'),
    items: past_consultations
  }));
};
var _default = exports.default = Consultation;